export const OFFLINE_NOTICE_TEXT =
  'Du bist offline – manche Daten oder Aktionen sind gerade nicht verfügbar.';

const DEBOUNCE_MS = 10_000;
let lastNoticeAt = -Infinity;

// A "network error" here means fetch() itself threw (DNS failure, dropped
// connection, CORS-as-opaque-failure, etc.) -- NOT a real HTTP response,
// even an error one. We only suppress error toasts for a short window after
// such a genuine network failure, so client-side validation/business errors
// (which arrive as real 4xx/5xx responses) are never swallowed. See
// noteNetworkError(), called from AuthContext's authFetch.
const NETWORK_ERROR_WINDOW_MS = 6_000;
let lastNetworkErrorAt = -Infinity;

export function noteNetworkError() {
  lastNetworkErrorAt = Date.now();
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('app:offline-notice'));
  }
}

export function isOfflineErrorSuppressed(severity) {
  return severity === 'error' && (Date.now() - lastNetworkErrorAt) < NETWORK_ERROR_WINDOW_MS;
}

export function offlineNoticeIfDue(now) {
  if (now - lastNoticeAt < DEBOUNCE_MS) return null;
  lastNoticeAt = now;
  return { message: OFFLINE_NOTICE_TEXT, severity: 'info' };
}

export function _resetOfflineNotice() {
  lastNoticeAt = -Infinity;
  lastNetworkErrorAt = -Infinity;
}
